import { combineReducers } from '@reduxjs/toolkit';
import auth from '@ameroservices-platform/attraction-backend/app/auth/store';
import fuse from './fuse';
import i18n from './i18nSlice';
import shared from './shared';
import cmsApp from '@ameroservices-platform/attraction-backend/app/main/apps/cms/cmsSlice';

const createReducer = asyncReducers => (state, action) => {
	const combinedReducer = combineReducers({
		auth,
		fuse,
		i18n,
		shared,
		cmsApp,
		...asyncReducers
	});

	/*
	Reset the redux store when user logged out
	 */
	if (action.type === 'auth/user/userLoggedOut') {
		// state = undefined;
	}

	return combinedReducer(state, action);
};

export default createReducer;
